import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { useDispatch, useSelector } from 'react-redux';
import { getDisease } from '../../reducer/diseaseSlice';
import { Avatar, Button, Divider, Drawer, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Menu, Typography, useMediaQuery, useTheme } from '@mui/material';
import { getIAAM } from '../../reducer/iaamSlice';
import { Outlet, useNavigate } from 'react-router-dom';
import { Suspense, useEffect, useState } from 'react';
import { getProfile } from '../../reducer/profileSlice';
import { CardBody, CardFooter, CardHeader } from '@material-tailwind/react';
import DengueSetting from '../setting/DengueSetting/DengueSetting';
import { Apps } from '@mui/icons-material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { getMapDataSelected, setMapDataSelected } from '../../reducer/mapDataSelectedSlice';
import MonitorDataShow from '../monitor/MonitorDataShow';
import { setEOCConfig } from '../../reducer/eocConfigSlice';

const drawerWidth = 300;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.only('xs')]: {
            marginLeft: 0,
        },
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        [theme.breakpoints.only('xs')]: {
            width: "100%",
        },
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));


function Layout() {
    const dispatch = useDispatch();
    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const mapDataSelected = useSelector(getMapDataSelected);
    const disease = useSelector(getDisease);
    const profile = useSelector(getProfile);
    const iaam = useSelector(getIAAM);
    const [open, setOpen] = useState((window.screen.width < 600) ? false : true);
    const [openShowData, setOpenShowData] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [appsAnchorEl, setAppsAnchorEl] = useState(null);


    let settingMenu;
    if (disease === "1") {
        settingMenu = <DengueSetting />
    } else if (disease === "2") {
        // settingMenu = <MalariaSetting />
    }

    // useEffect(() => {
    //     if (provinceData.length === 0) {
    //         localStorage.setItem("loading", pathname);
    //         navigate('/');
    //     }
    // }, [provinceData, pathname, navigate]);

    const toggleDrawerShowData = () => (event) => {
        dispatch(setMapDataSelected([]));
        setOpenShowData(!openShowData)
    };

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleApps = (event) => {
        setAppsAnchorEl(event.currentTarget);
    };

    const handleAppsClose = (event) => {
        setAppsAnchorEl(null);
    };

    useEffect(() => {
        if (mapDataSelected.length !== 0) {
            setOpenShowData(true);
        }
    }, [mapDataSelected])

    useEffect(() => {
        if (isMobileScreen) {
            setOpen(false);
        }
        // console.log(profile);
        if (profile === undefined) {

        }
    }, [profile])

    const contentShowData = (
        <MonitorDataShow />
    );

    const drawerItem = (
        <div className='overflow-hidden bg-gradient-to-tr from-orange-50 via-gray-100 to-slate-50'>
            <DrawerHeader className='flex items-center justify-between py-4'>
                <Typography variant="h6" color="blue-gray" className="ml-1">
                    ตั้งค่า
                </Typography>
                <IconButton
                    onClick={toggleDrawer}
                >
                    <svg
                        xmlns="https://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                        className="h-5 w-5"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>

                </IconButton>
            </DrawerHeader>
            <div>
                {settingMenu}
            </div>

        </div>
    )

    return (
        <Box sx={{ display: 'flex', overflow: 'hidden' }}>
            <AppBar position="fixed" open={open}>
                <Toolbar className='bg-white bg-gradient-to-bl from-orange-50 via-gray-100 to-slate-50'>
                    <Box display='flex' flexGrow={1}>
                        <IconButton
                            color="blue-gray"
                            aria-label="open drawer"
                            onClick={toggleDrawer}
                            edge="start"
                            sx={{
                                zIndex: 1,
                                mr: 2, ...(open && { display: 'none' })
                            }}
                        >
                            <MenuIcon className="h-6 w-6" />
                        </IconButton>
                        <img className="h-6 w-6 my-1.5 " alt="candice" src="/images/eoc-logo.png" />
                        <Typography
                            as="a"
                            href="#"
                            className="mr-4 ml-2 cursor-pointer py-1.5 text-black font-bold font-primary tracking-wide text-xl"
                        >
                            ทันระบาด <span style={{
                                color: '#cd6c4a'
                            }}>EOC</span>
                        </Typography>
                    </Box>
                    {/* <DiseaseList /> */}
                    <div>
                        <IconButton
                            size="large"
                            aria-label="show 17 new notifications"
                            color="inherit"
                            onClick={handleApps}
                        >
                            <Apps id="apps" className="h-6 w-6 text-l" sx={{ color: "#cd6c4a" }} />

                        </IconButton>
                        <Menu
                            id="apps-appbar"
                            anchorEl={appsAnchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(appsAnchorEl)}
                            onClose={handleAppsClose}
                        >
                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                {profile && profile.apps.map((item, idx) => (
                                    <div key={item.client_name}>
                                        <ListItem key={item.client_name} disablePadding alignItems="flex-start">
                                            <ListItemButton component="a" href={item.redirect_urls}>
                                                <ListItemAvatar>
                                                    {item.logo_url === "" ?
                                                        (<Avatar className='bg-deep-orange-700 font-primary p-2' src={item.logo_url}>
                                                            {item.client_name[0].toUpperCase()}
                                                        </Avatar>)
                                                        : (<img className='w-10 h-auto' alt={item.client_name} src={item.logo_url} />)}


                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={item.is_default === 0 ? (<span>{item.client_name}<VerifiedUserIcon color="success" fontSize="small" className='pl-1 pb-1' /></span>) : (item.client_name)}
                                                    secondary={item.description} />
                                            </ListItemButton>
                                        </ListItem>
                                        {idx < profile.apps.length - 1 && <Divider />}
                                    </div>
                                ))}
                            </List>
                        </Menu>
                        <IconButton
                            color="black"
                            onClick={handleMenu}
                        >
                            {/* <Badge badgeContent={4} color="secondary"> */}
                            <AccountCircleIcon sx={{ color: "#cd6c4a" }} />
                            {/* </Badge> */}
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            sx={(theme) => ({
                                '& .MuiMenu-list': {
                                    padding: 0
                                }
                            })}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <div className="w-80">
                                <CardHeader floated={false} className="h-fit">
                                    <img src={"/images/" + profile?.gender + ".jpg"} alt="profile-picture" />
                                </CardHeader>
                                <CardBody className="text-center">
                                    <Typography variant="h5" className="mb-2 font-primary text-orange-600">
                                        {profile?.displayName}
                                    </Typography>
                                    <Typography color="blue-gray" className="font-medium font-primary">
                                        {profile?.org_name}
                                    </Typography>
                                    <Typography color="blue-gray" className="font-medium font-primary text-sm">
                                        {profile?.mail}
                                    </Typography>
                                    <a href={process.env.REACT_APP_IAAM_PROFILE_PAGE} className="inline-block mt-2">
                                        <Button size="sm" variant="text" className="w-full flex items-center gap-2 font-primary text-base">
                                            จัดการโพรไฟล์
                                            <svg
                                                xmlns="https://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={2}
                                                stroke="currentColor"
                                                className="h-4 w-4"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                                                />
                                            </svg>
                                        </Button>
                                    </a>
                                </CardBody>
                                <CardFooter className="pt-0">
                                    <Button
                                        // ripple={false}
                                        fullWidth={true}
                                        onClick={() => {
                                            if (iaam) {
                                                iaam.logout();
                                            }
                                        }}

                                        className="font-primary text-base bg-blue-gray-900/10 text-blue-gray-900 shadow-none hover:scale-105 hover:shadow-none focus:scale-105 focus:shadow-none active:scale-100"
                                    >
                                        ออกจากระบบ
                                    </Button>
                                </CardFooter>
                            </div>
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    width: "90%",
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: "90%",
                        boxSizing: 'border-box',
                    },
                }}
                variant="temporary"
                anchor="left"
                open={open}
            >
                {drawerItem}
            </Drawer>
            <Drawer
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                {drawerItem}
            </Drawer>
            <Drawer
                anchor={'right'}
                open={openShowData}
                onClose={toggleDrawerShowData()}
                onOpen={toggleDrawerShowData()}
            >
                {contentShowData}
            </Drawer>
            <Main open={open} className='p-0 mt-[60px] overflow-auto'>
                <Suspense>
                    <Outlet />
                </Suspense>
            </Main>
        </Box>
    );
}

export default Layout